import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import Logo from '@/components/common/Logo';

const TermosDeUso = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-[#1A1A1A] text-white py-4">
        <div className="max-w-4xl mx-auto px-4 flex items-center gap-4">
          <Link to="/login" className="text-white/70 hover:text-white">
            <FiArrowLeft className="text-xl" />
          </Link>
          <Logo size="sm" />
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-[#1A1A1A] mb-8">Termos de Uso</h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <p className="text-sm text-gray-500">Última atualização: Janeiro de 2025</p>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">1. Aceitação dos Termos</h2>
            <p>
              Ao acessar e usar o aplicativo BarueriFlash, você concorda em cumprir estes Termos de Uso. 
              Se você não concordar com qualquer parte destes termos, não deve usar nosso serviço.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">2. Descrição do Serviço</h2>
            <p>
              O BarueriFlash é uma plataforma de marketplace que conecta compradores, vendedores (lojistas) 
              e entregadores na cidade de Barueri, SP. Oferecemos:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Plataforma para lojistas cadastrarem e venderem produtos eletrônicos</li>
              <li>Sistema de compras online para clientes</li>
              <li>Serviço de entrega rápida através de entregadores parceiros</li>
              <li>Processamento de pagamentos via PIX (Mercado Pago)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">3. Cadastro de Usuários</h2>
            <p>Para utilizar nossos serviços, você deve:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Ter pelo menos 18 anos de idade</li>
              <li>Fornecer informações verdadeiras e atualizadas</li>
              <li>Manter a confidencialidade de sua senha</li>
              <li>Ser responsável por todas as atividades em sua conta</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">4. Área de Cobertura</h2>
            <p>
              O serviço BarueriFlash opera exclusivamente na cidade de <strong>Barueri, São Paulo</strong>. 
              Pedidos com endereços fora desta área não serão aceitos pelo sistema.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">5. Pagamentos e Taxas</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Clientes:</strong> Pagam o valor dos produtos + taxa de entrega (R$ 15,00)</li>
              <li><strong>Lojistas:</strong> Pagam comissão por venda (R$ 2,00 ou R$ 8,00 dependendo do valor)</li>
              <li><strong>Entregadores:</strong> Recebem R$ 10,00 por entrega realizada</li>
            </ul>
            <p className="mt-4">
              Todos os pagamentos são processados via PIX através do Mercado Pago. O valor é depositado 
              diretamente na conta do lojista.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">6. Responsabilidades</h2>
            <h3 className="text-lg font-medium mt-4 mb-2">Do BarueriFlash:</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Manter a plataforma funcionando de forma segura</li>
              <li>Processar pagamentos de forma correta</li>
              <li>Mediar conflitos entre usuários quando necessário</li>
            </ul>
            
            <h3 className="text-lg font-medium mt-4 mb-2">Dos Lojistas:</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Garantir a qualidade e autenticidade dos produtos</li>
              <li>Manter informações atualizadas sobre estoque e preços</li>
              <li>Preparar os pedidos em tempo hábil</li>
            </ul>
            
            <h3 className="text-lg font-medium mt-4 mb-2">Dos Entregadores:</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Realizar entregas com cuidado e agilidade</li>
              <li>Verificar o código de segurança na entrega</li>
              <li>Manter conduta profissional</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">7. Cancelamentos e Reembolsos</h2>
            <p>
              Pedidos podem ser cancelados antes do início da entrega. Após o pagamento via PIX, 
              reembolsos devem ser solicitados diretamente ao lojista ou através do suporte BarueriFlash.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">8. Modificações</h2>
            <p>
              Reservamo-nos o direito de modificar estes termos a qualquer momento. 
              Alterações significativas serão comunicadas aos usuários.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">9. Contato</h2>
            <p>
              Para dúvidas sobre estes Termos de Uso, entre em contato através do email: 
              <a href="mailto:contato@barueriflash.com.br" className="text-[#DC143C] hover:underline ml-1">
                contato@barueriflash.com.br
              </a>
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#DC143C] hover:underline font-medium"
          >
            <FiArrowLeft />
            Voltar
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#1A1A1A] text-white py-6 mt-8">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/faq" className="text-white/60 hover:text-white">FAQ</Link>
            <Link to="/sobre" className="text-white/60 hover:text-white">Sobre</Link>
            <Link to="/privacidade" className="text-white/60 hover:text-white">Privacidade</Link>
          </div>
          <p className="text-white/40 text-center text-xs mt-4">© 2025 BarueriFlash - Todos os direitos reservados</p>
        </div>
      </footer>
    </div>
  );
};

export default TermosDeUso;
